export const businessRoutes = {
	registerOperator: '/:language/register/operator/:registerToken',
	confirmOperator: '/:language/confirmation/operator',
	register: '/:language/register',
	registerFinalize: '/:language/register/finalize',
	activation: '/:language/activation',
	confirmation: '/:language/:id/confirmation',
	forgotten: '/:language/forgotten',
	login: '/:language/login',
	logout: '/:language/logout',
	passwordChange: '/:language/password/change',
	passwordChangeToken: '/:language/password/change/:token',
	dashboard: '/:language',
	surveys: '/:language/surveys',
	surveysDashboard: '/:language/surveys/dashboard/:id',
	surveyAdd: '/:language/survey/add',
	surveyEdit: '/:language/survey/edit/:id',
	surveyEditSummary: '/:language/survey/edit/:id/summary',
	surveyEditSummaryReports: '/:language/survey/edit/:id/summary/reports',
	surveyQuestionAdd: '/:language/survey/add/:id/questions',
	surveyQuestionEdit: '/:language/survey/edit/:id/questions',
	surveySummary: '/:language/survey/add/:id/summary',
	surveySummaryInterviewer:
		'/:language/survey/add/:id/summary/interviewer/:iid',
	surveySummaryAddInterviewerQuestionnaire:
		'/:language/survey/add/:id/summary/interviewer/:iid/questionnaire/:qid',
	surveySummaryEditInterviewer:
		'/:language/survey/edit/:id/summary/interviewer/:iid',
	surveySummaryEditInterviewerQuestionnaire:
		'/:language/survey/edit/:id/summary/interviewer/:iid/questionnaire/:qid',
	surveyAddPanelistList: '/:language/survey/add/:id/summary/panelists/list',
	surveyEditPanelistList: '/:language/survey/edit/:id/summary/panelists/list',
	
	surveyAddPanelistManagement:
		'/:language/survey/add/:id/summary/panelists/management',
	surveyEditPanelistManagement:
		'/:language/survey/edit/:id/summary/panelists/management',
	surveyAddImport: '/:language/survey/add/:id/summary/panelists/import',
	surveyEditImport: '/:language/survey/edit/:id/summary/panelists/import',
	surveyPreview: '/:language/survey/preview/:id',
	surveyPreviewRejected: '/:language/survey/preview/:id/rejected',
	surveyPreviewAccepted: '/:language/survey/preview/:id/accepted',
	interviewers: '/:language/interviewers',
	interviewerDetails: '/:language/interviewers/:id/details',
	settings: '/:language/settings',
	'404': '/:language/404',
};
export const panelistRoutes = {
	accepted: '/:language/accepted',
	submited: '/:language/submitted',
	rejected: '/:language/rejected',
	limitExceeded: '/:language/limit-exceeded',
	notFound: '/:language/not-found',
	error: '/:language/error',
	integration: '/:language/integration',
	'404': '/:language/404',
	annoinimousQuestionaire: '/:language/:sid/:token',
	panelistQuestionaire: '/:language/:hash',
};
export const interviewerRoutes = {
	register: '/:language/register/:registerToken',
	activation: '/:language/activation',
	confirmation: '/:language/confirmation',
	login: '/:language/login',
	forgotten: '/:language/forgotten',
	resetPassword: '/:language/password/change/:token',
	changePasswordLogged: '/:language/password/change',
	registrationfinalize: '/:language/registration/finalize',
	dashboard: '/:language',
	survey: '/:language/survey/:id',
	settings: '/:language/settings',
};
export const adminRoutes = {
	login: '/:language/login/',
	dashboard: '/:language',
	company: '/:language/company/:id/summary',
	'404': '/:language/404',
};
